import script from "./Snappy-Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Snappy-Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Snappy-Inbox.vue?vue&type=style&index=0&id=5086c80b&scoped=true&lang=css"
import "./Snappy-Inbox.vue?vue&type=style&index=1&id=5086c80b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5086c80b"]])

export default __exports__